import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../../components/SectionFormContainer'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import { BREED_MIXES, BREED_MIX_TYPES, GROOMING_PROFILE_KEYS } from './constants'
import useGroomingProfile from './hooks/useGroomingProfile'

const BreedMix = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const { attr, title = '', subtext = '' } = props
	const { loading } = useGroomingProfile()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...wizard_state }
			newValues[attr] = type
			newValues[GROOMING_PROFILE_KEYS.breeds] = type === BREED_MIX_TYPES.unknown ? ['Mixed'] : []
			newValues[GROOMING_PROFILE_KEYS.coat_type] = ''
			newValues[GROOMING_PROFILE_KEYS.coat_length] = ''
			newValues[GROOMING_PROFILE_KEYS.grooming_level] = ''
			newValues[GROOMING_PROFILE_KEYS.allowed_grooming_services] = []

			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	const options = useMemo(() => {
		const o = Object.entries(BREED_MIXES).map(([key, value]) => {
			return {
				title: value,
				disabled: loading || wizard_state[attr] === key,
				selected: wizard_state[attr] === key,
				onSelected: () => handleSelection(key)
			}
		})

		return o
	}, [handleSelection, loading, wizard_state, attr])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default BreedMix
